import React from 'react';
import { mockData } from '../data/mock';

const BrandLogo = ({ className = '' }) => {
  const { hero } = mockData;

  return (
    <div className={`flex flex-col items-center text-center ${className}`}>
      <img
        src={hero.logoMark}
        alt=""
        aria-hidden="true"
        className="w-44 sm:w-56 md:w-64 lg:w-72 h-auto object-contain drop-shadow-2xl"
      />
      <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-white tracking-[0.35em] mt-5 -mr-[0.35em]">
        PRODUCTIONS
      </p>
      <p className="text-base sm:text-lg md:text-xl text-orange-400 font-light tracking-[0.25em] mt-3 uppercase">
        {hero.subtitle}
      </p>
    </div>
  );
};

export default BrandLogo;
